import React, { createContext, useState } from 'react'

interface BackendTokenContextType {
  token: string | null
  setToken: (token: string | null) => void
}

export const BackendTokenContext = createContext<BackendTokenContextType>({
  token: null,
  setToken: () => {},
})

export const BackendTokenProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [token, setToken] = useState<string | null>(null)

  return (
    <BackendTokenContext.Provider value={{ token, setToken }}>
      {children}
    </BackendTokenContext.Provider>
  )
}
